export default {
  ghi_chu: "Ghi chú",
  cs_huy_ve: "Chính sách hủy vé",
  cs_nha_xe: "Chính sách nhà xe",
  huy_tu: "Hủy từ",
  den_truoc: "Đến trước",
  phi_huy: "Phí hủy",
  gia_tri_don_hang: "Giá trị đơn hàng",
  dang_ngay: 'Đăng ngày',
  sau_khi_dat: 'Sau khi đặt',
  mien_phi: 'Miễn phí',
  truoc: 'Trước',
  tieng_truoc_khi_khoi_hanh: 'tiếng trước giờ khởi hành',
  danh_gia: 'Đánh giá',
  hinh_anh: 'Hình ảnh',
  tien_ich: 'Tiện ích',
  chinh_sach: 'Chính sách',
  gio_khoi_hanh: 'Giờ khởi hành'
};
